<div class="row">
  <div class="col">
    <ngx-datatable
      class="data-table table-responsive task-list-table"
      [rows]="data?.content"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="50"
      [limit]="10"
      [rowHeight]="40"
    >
      <ngx-datatable-column [flexGrow]="2" name="host">
        <ng-template ngx-datatable-header-template>
          {{ 'Host' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-host-mode-label [siteMode]="row.mode" />
          <app-managed-service-label [managed]="row.managed" />
          {{ row.name }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="3" name="cluster">
        <ng-template ngx-datatable-header-template>
          {{ 'Statut' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-site-status-full [site]="row" />
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="3" name="cluster">
        <ng-template ngx-datatable-header-template>
          {{ 'Cluster' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.cluster.name }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column [flexGrow]="3" name="organization">
        <ng-template ngx-datatable-header-template>
          {{ 'Organization' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.owner.name }}
        </ng-template>
      </ngx-datatable-column>

      <!--      <ngx-datatable-column [flexGrow]="2" name="bandwidth">
        <ng-template ngx-datatable-header-template>
          {{ 'Graph.seriesName.bandwidth' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.bandwidthIn + row.bandwidthOut }}
        </ng-template>
      </ngx-datatable-column>-->

      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <app-table-pager [data]="data" [page]="page" (changePage)="changePage($event)" />
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
